import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import useCreateLocation from './queries/useCreateLocation';

import FormBase from '@/components/forms/new/FormBase';
import {
    breadCrumbTrail,
    addHeader as header,
    initialState,
    regionsAndLocationsPath,
} from './constants';
import LocationIdField from './formFields/LocationIdField';
import LocationNameField from './formFields/LocationNameField';

const LocationAdd = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { darkMode } = useSelector((state) => state.settings);

    const handleBack = () => {
        dispatch({
            type: 'CHANGE_TAB_VIEW',
            payload: { level1: 1, level2: 0 },
        });
        navigate(regionsAndLocationsPath);
    };

    const handleSuccess = (data) => {
        toast.success('Location created successfully!');
        navigate(`/regions-and-locations/locations/edit/${data.id}`);
    };

    const handleError = (error) => {
        console.error('Failed to create location:', error);
        toast.error('Failed to create location. Please try again.');
    };

    const { mutate: createLocation, isPending } = useCreateLocation(
        handleSuccess,
        handleError,
    );

    const finalFormSubmit = async (values) => {
        if (!values.id || !values.location) {
            console.error('Location ID and Location are required');
            return;
        }
        createLocation({ id: values.id, location: values.location });
    };

    const formFields = (errors, touched) => [
        <LocationIdField
            key="id"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
        <LocationNameField
            key="location"
            errors={errors}
            touched={touched}
            darkMode={darkMode}
        />,
    ];

    return (
        <FormBase
            isSubmitDisabled={isPending}
            isLoading={isPending}
            breadCrumbTrail={breadCrumbTrail}
            header={header}
            initialValues={initialState}
            finalFormSubmit={finalFormSubmit}
            backLink={handleBack}>
            {({ errors, touched }) => formFields(errors, touched)}
        </FormBase>
    );
};

export default LocationAdd;
